export function shouldUseActualPrice(listPrice?: { amount: number }, actualPrice?: { amount: number }): boolean {
  return !!listPrice && !!actualPrice && (listPrice.amount === 0 || listPrice.amount > actualPrice.amount); // Innovadis custom: when list price is 0 return true and use actual price
}
